module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "fill": "none",
      "height": "17",
      "viewBox": "0 0 20 17",
      "width": "20",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": "black"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2.253V15.253M10 2.253C8.832 1.477 7.246 1 5.5 1C3.754 1 2.168 1.477 1 2.253V15.253C2.168 14.477 3.754 14 5.5 14C7.246 14 8.832 14.477 10 15.253M10 2.253C11.168 1.477 12.754 1 14.5 1C16.247 1 17.832 1.477 19 2.253V15.253C17.832 14.477 16.247 14 14.5 14C12.754 14 11.168 14.477 10 15.253",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc261ed8","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/book.vue
// module id = 94372070a9a246643730
// module chunks = 89